'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require('../utils/common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DatePickerFilter = function () {
    function DatePickerFilter(showHideDialog) {
        (0, _classCallCheck3.default)(this, DatePickerFilter);

        this.showHideDialog = showHideDialog;
        this.releaseDateFilterRegex = /,?\s?"?Release((From)|(To))"?\s?:\s?"?[0-9\-]+"?\s?,?/ig;
    }

    (0, _createClass3.default)(DatePickerFilter, [{
        key: 'fillDatePickerValues',
        value: function fillDatePickerValues() {
            var filterObject = {};
            try {
                var filterQuery = unescape(_common2.default.getQueryStringParam('filter'));
                filterObject = JSON.parse('{' + filterQuery + '}') || {};
            } catch (e) {
                console.error('Error in parsing filter query to JSON. Method: fillDatePickerValues.', e);
            }

            this.setupDatePicker('dateFromPicker', filterObject.ReleaseFrom);
            this.setupDatePicker('dateToPicker', filterObject.ReleaseTo);
        }
    }, {
        key: 'setupDatePicker',
        value: function setupDatePicker(pickerId, initValue) {
            var datePickerInitData = { locale: 'cs', format: 'L' };
            var pickerInput = void 0;
            if (initValue) datePickerInitData.date = initValue;else if (pickerInput = document.querySelector('.date-picker-dialog-inner #' + pickerId + ' input')) {
                pickerInput.value = '';
            }
            $('.date-picker-dialog-inner #' + pickerId).datetimepicker(datePickerInitData);
        }
    }, {
        key: 'registerFilterByDateClick',
        value: function registerFilterByDateClick() {
            var _this = this;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(document.querySelectorAll('.popup-date-picker-filter-button')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var datePickerButton = _step.value;

                    if (datePickerButton.clickRegistered) continue;

                    datePickerButton.addEventListener('click', function () {
                        _this.filterByDateButtonClick();
                    });
                    datePickerButton.clickRegistered = true;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(document.querySelectorAll('.popup-date-picker-cancel-button')), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var cancelButton = _step2.value;

                    if (cancelButton.clickRegistered) continue;

                    cancelButton.addEventListener('click', function () {
                        _this.filterByDateButtonClick(true);
                    });

                    cancelButton.clickRegistered = true;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: 'filterByDateButtonClick',
        value: function filterByDateButtonClick() {
            var isCancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var paramsArray = [];

            var otherParams = _common2.default.getQueryStringParam('filter');
            otherParams = unescape(otherParams).replace(this.releaseDateFilterRegex, '');
            paramsArray.push(otherParams);
            if (!isCancel) {
                paramsArray.push(this.setUpDateFilter('dateFromPicker', 'ReleaseFrom'));
                paramsArray.push(this.setUpDateFilter('dateToPicker', 'ReleaseTo'));
            } else {
                this.setEmptyDatePicker('dateFromPicker');
                this.setEmptyDatePicker('dateToPicker');
            }

            var url = '' + location.origin + location.pathname + '?filter=' + paramsArray.filter(function (p) {
                return p && p.length > 0;
            }).join(',');
            _common2.default.updateSearchQueryByUrl(url);
            this.showHideDialog(false);
        }
    }, {
        key: 'setUpDateFilter',
        value: function setUpDateFilter(pickerElementId, queryParamName) {
            var dateFromValue = $('#' + pickerElementId).data('DateTimePicker').date();
            return dateFromValue && $('#' + pickerElementId + ' > input').val() ? '"' + queryParamName + '":"' + _common2.default.formatIsoDateOnly(dateFromValue) + '"' : '';
        }
    }, {
        key: 'setEmptyDatePicker',
        value: function setEmptyDatePicker(pickerElementId) {
            $('#' + pickerElementId).datetimepicker().val('');
        }
    }]);
    return DatePickerFilter;
}();

exports.default = DatePickerFilter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/modules/datePickerFilter.js
// module id = 958
// module chunks = 0